// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","alertPersistent":"_2UmORVaaOVEEp6u5QGdi2s","closeIcon":"lsYmI2-d4w7TY-qGtFYQK"};